export const validation = {
  firstName: "First name is required",
  fullName: "Full name is required",
  lastName: "Last name is required",
  middlename: "Middle name is required",
  fatherName: "Father name is required",
  motherName: "Mother name is required",
  birthCity: "Birth city is required",
  birthDate: "Birth date is required",
  deathDate: "Death date is required",
  spouse: "Spouse name is required",
  siblingName: "Sibling name is required",
  childrenName: "Children name is required",
  myBio: "Bio is required",
  facebook: "Facebook URL is required",
  twitter: "Twitter URL is required",
  instagram: "Instagram URL is required",
  validUrl: " Please enter valid URL",
  marriageDate: "Marriage Date is required",
  status: "Status is required",
  birthState: "Birth state is required",
  description: "Description is required",
  title: "Timeline title is required",
  albumTitle: "Album name is required",
  comment: "Comment is required",
  gender: "Gender is required",
  profileLink: "Profile link is required",
  relation: "Relation is required",
  permission: "Permission is required",
  name: "Name is required",
  country: "Country is required",
  date: "Date is required",
  location: "Address is required",
  album: "Album title is required",
  albumImage: "Album Image is required",
};
